<div  class="amadeus-direct-style">
  <div class="loyalty-wrap business-wrap">
    <div *ngIf="!isSnow" class="amadeus-direct-style">
      <div class="row">
        <img
          class="img-fluid col-lg-12 mx-0 px-0 g-0"
          alt="Responsive banner"
          src="/assets/images/banner/plusme-banner.png"
        />
      </div>
    </div>

    <div class="container pt-lg-9 px-lg-10 pt-md-9 px-md-10">
      <div class="row px-lg-8 px-md-8">
        <div class="col-lg-2" *ngIf="displayView === 'loginForm'"></div>
        <div class="col-lg-8">
          <ng-container *ngIf="agentState?.isLoading || agentAccountState?.isLoading">
            <spinner fixed="true"></spinner>
          </ng-container>
          <ng-container *ngIf="!customerConfigState?.isLoading">
            <ng-container [ngSwitch]="displayView">
              <app-loyalty-enroll-now
                *ngSwitchCase="'enrollment'"
                (viewLayout)="showLayout($event)"
                [isAccountEnabled]="isAccountEnabled"
                [customerConfig]="customerConfigState?.customerConfig"
              >
              </app-loyalty-enroll-now>
              <app-loyalty-login-form
                *ngSwitchCase="'loginForm'"
                (viewLayout)="showLayout($event)"
                [customerConfig]="customerConfigState?.customerConfig"
              ></app-loyalty-login-form>
              <app-loyalty-finish-form
                *ngSwitchCase="'finishForm'"
                [agentState]="agentState"
                [customerConfig]="customerConfigState?.customerConfig"
              ></app-loyalty-finish-form>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
